<template>
    <div class="space-y-0.5">
        <div v-for="(option) in preparedOptions">
            <input type="hidden" class="hidden" :name="getName(option.value)" value="">
            <label class="flex space-x-2 cursor-pointer">
                <input type="checkbox" class="w-3 h-3 mt-1"
                       :name="getName(option.value)"
                       v-model="values"
                       @update:modelValue="update"
                >
                <span class="fc-label mb-0">{{ option.label }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'label',
        'name',
        'value',
        'options',
    ],
    data() {
        return {
            values: this.values || [],
        };
    },
    computed: {
        preparedOptions() {
            let opts = this.options
            let options = [];

            // Если нам передали массив объектов
            if (Array.isArray(opts)) {
                opts.forEach((option, index) => {
                    if (typeof option === 'object') {
                        options.push(option);
                    } else {
                        options.push({
                            value: index,
                            label: option
                        });
                    }
                });
            } else {
                Object.keys(opts).forEach((id) => {
                    let value = opts[id];
                    options.push({
                        value: id,
                        label: value
                    });
                });
            }

            return options;
        },
    },
    methods: {
        isChecked(val) {
            return this.value && this.value.includes(val);
        },
        getName(val) {
            return this.name + '[' + val + ']';
        },
        update() {
            this.$emit('update:modelValue',this.values);
        }
    }
}
</script>
